import { render } from "./Restarting.vue?vue&type=template&id=15822efd&scoped=true"
import script from "./Restarting.vue?vue&type=script&lang=js"
export * from "./Restarting.vue?vue&type=script&lang=js"

import "./Restarting.vue?vue&type=style&index=0&id=15822efd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15822efd"]])

export default __exports__